import Header from "../components/header/header";

import { useLocation } from "react-router";
import { Footer } from "../blocks/Footer/Footer";
import { BreadCrumbs } from "../components/BreadCrumbs/BreadCrumbs";
import { _flexDirection, _gap, Container } from "../components/Container/Container";
import { ScrollBlock } from "../components/others/ScrollBlock";
import "../core/core.css";
import { DiscontBanner } from "../entities/discount/ui/DiscontBaner/DiscontBanner";
import { OrderProvider, useOrder } from "../entities/order/context/OrderContext";
import { Faq } from "../features/faq/faq";
import { Howwork } from "../features/howwork/howwork";
import { LeftCatalog } from "../features/left-catalog/ui/LeftCatalog/LeftCatalog";
import { OrderCreateMorda } from "../features/order-create/ui/OrderCreateMorda/OrderCreateMorda";
import { OrderPayment } from "../features/order-create/ui/OrderPayment/OrderPayment";
import { ServiceBlock } from "../features/service-block/ServiceBlock";
import { ServicesNew } from "../features/service-list/ui/ServicesNew";
import { OrderMenu } from '../shared/components/MenuDown/MenuDown';
import { PageContainer } from "../shared/components/PageContainer/PageContainer";
import { SplitContainer } from "../shared/components/SplitContainer/SplitContainer";
import { Skeleton } from '../shared/components/ui/skeleton';

const UslugaNew = () => {
    return (
        <OrderProvider>
            <UslugaSeo></UslugaSeo>
            <ScrollBlock></ScrollBlock>
            <DiscontBanner></DiscontBanner>
            <PageContainer>
                <Header>
                    <BreadcrumbsService></BreadcrumbsService>
                </Header>
                <SplitContainer>
                    <LeftCatalog></LeftCatalog>
                    <ServiceContent />
                </SplitContainer>
                <OrderMenu></OrderMenu>
                <Footer></Footer>
            </PageContainer>
        </OrderProvider>
    );
};
const UslugaSeo = () => {
    const order = useOrder();

    return (
        <>
            <title>{order.service?.base_info.title_seo}</title>
            <link rel="canonical" href={`https://hmrep.ru/uslugi/${order.service?.url_slog}`} />
            <meta name="description" content={order.service?.base_info.description_seo} />
            <meta property="og:title" content={order.service?.base_info.title_seo} />
            <meta property="og:description" content={order.service?.base_info.description_seo} />
        </>
    )
}

const ServiceContent = () => {
    const { isLoading } = useOrder();

    if (isLoading && typeof window !== "undefined") {
        window.scrollTo(0, 0);
        return (
            <>
                <Container direction={_flexDirection.column} gap={_gap.m12}>
                    <Skeleton className="h-60 w-full" />
                    <Skeleton className="h-60 w-full" />
                    <Skeleton className="h-60 w-full" />
                    <Skeleton className="h-60 w-full" />
                    <Skeleton className="h-60 w-full" />
                    <Skeleton className="h-60 w-full" />
                </Container>
                <Skeleton className="h-40 w-full" style={{ maxWidth: "323px", minWidth: "300px", height: "248px" }} />
            </>
        );
    }

    return (
        <>
            <Container direction={_flexDirection.column} gap={_gap.m12}>
                <OrderCreateMorda></OrderCreateMorda>
                <OrderPayment is_desktop={false}></OrderPayment>
                <Howwork></Howwork>
                <ServiceBlock></ServiceBlock>
                <Faq></Faq>
                <ServicesNew></ServicesNew>
            </Container>
            <OrderPayment is_desktop={true}></OrderPayment>
        </>
    );
};

export default UslugaNew;

const BreadcrumbsService = () => {
    const { service, isLoading } = useOrder();
    const location = useLocation();

    const breadcrumbs = [
        {
            name: "Главная",
            url: "/"
        },
        {
            name: "Каталог",
            url: "/uslugi/"
        },
        {
            name: isLoading ? "Загрузка..." : (service?.base_info.breadlink_name || "Новая услуга"),
            url: location.pathname
        }
    ]

    return <BreadCrumbs links={breadcrumbs}></BreadCrumbs>
}